import PackageTabs from './package-tabs';

export default PackageTabs;